<template>
    <div class="margin-t-4">
        <div class="flex gap-2 column-tablet">
            <div class="filters-wrapper">
                <div class="text-l uppercase add-letter-spacing margin-b-1">Filters</div>
                <div class="flex column gap-2 row-tablet column-mobile">

                    <div class="contact-us_block">
                        <label class="text-s text-color-weak" for="keyword">Keyword</label>
                        <div>
                            <input id="keyword" type="text" name="keyword" v-model="query">
                        </div>
                    </div>

                    <div class="flex column">
                        <label for="department-select" class="text-s text-color-weak">Job Department</label>
                        <select id="department-select" class="nc-select" v-model="selectedDepartment">
                            <option value="all">All departments</option>
                            <template v-for="(department, slug) in departments">
                                <option :value="slug">{{ department }}</option>
                            </template>
                        </select>
                    </div>

                    <div class="flex column">
                        <label for="location-select" class="text-s text-color-weak">Location</label>
                        <select id="location-select" class="nc-select" v-model="selectedLocation">
                            <option value="all">All locations</option>
                            <template v-for="(location, slug) in locations">
                                <option :value="slug">{{ location }}</option>
                            </template>
                        </select>
                    </div>

                </div>
            </div>
            <div v-if="results.length > 0" class="grow">
                <div v-if="pagination" class="h3">{{ pagination.total }} Results</div>

                <div class="margin-b-3 flex column gap-2">
                    <div v-for="item in results" :key="item.id">
                        <a :href="item.url" class="flex justify-between no-text-decoration padding-v-3 border-bottom">
                            <div>
                                <div class="text-xl text-color-weak margin-b-1">{{ item.title }}</div>
                                <div class="text-color-weak">{{ formatedLocations(item) }}</div>
                            </div>
                            <div class="btn-link-arrow"><span>Apply</span></div>
                        </a>
                    </div >
                </div>

                <Pagination
                    class="flex justify-center align-center"
                    :current-page="pagination.current_page"
                    :total-pages="pagination.last_page"
                    @change-page="paginate"
                />

                <div class="text-align-center">{{ resultsQuantity }}</div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue'
import Pagination from "./../Pagination.vue";


const results = ref([])
const departments = ref([])
const locations = ref([])
const pagination = ref({})

const selectedDepartment = ref('all')
const selectedLocation = ref('all')
const query = ref('')

const formatedLocations = (item) => {
    return Object.values(item.locations).join('; ')
}

const resultsQuantity = computed(() => {
    const from = (pagination.value.current_page - 1) * pagination.value.per_page + 1
    const to = Math.min(pagination.value.current_page * pagination.value.per_page, pagination.value.total)
    return `Showing ${from} to ${to} of ${pagination.value.total}`
})

const paginate = async (page) => {
    await fetchResults(page);
}

const buildQueryString = (page) => {
    const params = new URLSearchParams()
    params.append('page', page ? page : 1)

    if (query.value !== '') {
        params.append('q', query.value)
    }

    if (selectedDepartment.value !== 'all') {
        params.append('department', selectedDepartment.value)
    }

    if (selectedLocation.value !== 'all') {
        params.append('location', selectedLocation.value)
    }

    return params.toString()
}

const fetchResults = async (page = 1) => {
    try {
        const queryString = buildQueryString(page)

        const res = await fetch(`/api/open-positions?${queryString}`)
        const data = await res.json()

        results.value = data.data
        departments.value = data.departments
        locations.value = data.locations
        pagination.value = {
            last_page: data.last_page,
            current_page: data.current_page,
            total: data.total,
            per_page: data.per_page,
        }
    } catch (err) {
        results.value = []
    }
}

watch(query, () => {
    fetchResults()
})

watch(selectedDepartment, () => {
    fetchResults()
})

watch(selectedLocation, () => {
    fetchResults()
})

onMounted(() => {
    const params = new URLSearchParams(window.location.search)

    const q = params.get('q')
    const location = params.get('location')

    if (location) selectedLocation.value = location
    if (q) query.value = q

    fetchResults()
})

</script>
